/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_All_UsersInputs */

const en_admin_users_all_users = /** @type {(inputs: Admin_Users_All_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Users`)
};

/**
* | output |
* | --- |
* | "All Users" |
*
* @param {Admin_Users_All_UsersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_all_users = /** @type {((inputs?: Admin_Users_All_UsersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_All_UsersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_all_users(inputs)
});
export { admin_users_all_users as "admin.users.all_users" }